import { Component } from '@angular/core';
import { GoogleMapsService } from './shared/services';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: []
})
export class AppComponent {
	title = 'ViSec';
	constructor(private readonly googleService: GoogleMapsService) {
		this.googleService.loadGoogleMapsApi();
	}
}
